import { render, staticRenderFns } from "./ImportProductsModal.vue?vue&type=template&id=dbbc9618&scoped=true&"
import script from "./ImportProductsModal.vue?vue&type=script&lang=js&"
export * from "./ImportProductsModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportProductsModal.vue?vue&type=style&index=0&id=dbbc9618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbc9618",
  null
  
)

export default component.exports